import { GeneratedReceiptResultViewModel } from '../generated/view-models/generated-receipt-result.view-model';

export class ReceiptResultViewModel extends GeneratedReceiptResultViewModel {

}
